import { validate as veeValidate } from 'vee-validate';

export default {
  params: ['template', 'rules'],
  validate: async (value, { template, rules }) => {
    const claimConvictionFieldsSorted = Object.keys(template).sort();

    const claimConvictionValidity = await Promise.all(
      claimConvictionFieldsSorted.map(field => veeValidate(value[field], rules[field]).then(r => ({ ...r, field }))),
    );

    return {
      valid: !claimConvictionValidity.some(({ valid }) => valid === false),
      required: true,
    };
  },
  computesRequired: true,
};
